import React from 'react';
import ProfileImage from '../ProfileImage';
import { Agent } from '@th/shared/src/types/Agent';
import Link from 'next/link';

type Props = {
  agent: Agent;
};

export default function AgentProfile({ agent }: Props) {
  return (
    <div>
      <h3 className="mb-2">Presented by</h3>
      <div>
        <div className="flex flex-col items-center md:items-start">
          {Boolean(agent.profileImageUri) && (
            <ProfileImage source={agent.profileImageUri} />
          )}
          <Link href={`/u/${agent.username}`} target="_blank">
            <p className="mt-4">@{agent.username}</p>
          </Link>
        </div>
        <p>{agent.legalName}</p>
        <p>{agent.brokerageName}</p>
      </div>
    </div>
  );
}
